import React from 'react'
import { FormError } from './WorkspaceProfileURL.styles'
import { FormikErrors, FormikProps, FormikTouched } from 'formik'

const URL_UNAVAILABLE = `This URL isn’t available.`

const getErrorMessage = <
  TName extends string,
  TFormValues extends Record<TName, string>,
>({
  touched,
  errors,
  isUrlAvailable,
  name,
}: {
  touched: FormikTouched<TFormValues>
  errors: FormikErrors<TFormValues>
  isUrlAvailable: boolean
  name: TName
}) => {
  if (touched[name]) {
    return !isUrlAvailable ? URL_UNAVAILABLE : errors[name]
  }

  return undefined
}

export interface WorkspaceProfileUrlFieldErrorProps<
  TName extends string,
  TFormValues extends Record<TName, string>,
> {
  name: TName
  formikBag: FormikProps<TFormValues>
  isUrlAvailable: boolean
}

export const WorkspaceProfileUrlFieldError = <
  TName extends string,
  TFormValues extends Record<TName, string>,
>({
  name,
  formikBag,
  isUrlAvailable,
}: WorkspaceProfileUrlFieldErrorProps<TName, TFormValues>) => {
  const { touched, errors } = formikBag

  const errorMessage = getErrorMessage({
    name,
    touched,
    errors,
    isUrlAvailable,
  })

  return <FormError>{errorMessage}</FormError>
}
